import http from "./http";
const baseUrl = "/v1/api/certificate";

const { get, post } = http;
const certificateAdd = (params: any) => post(`${baseUrl}/developerCert/add`, params); // 新增开发者证书
const certificateAbolish = (params: any) => post(`${baseUrl}/developerCert/abolish/${params.id}`); // 废除开发者证书
const certificateDelete = (params: any) => post(`${baseUrl}/developerCert/remove/${params.id}`); // 删除开发者证书
const certificateDownload = (params: any) =>
  get(`${baseUrl}/developerCert/download/${params.id}`, { responseType: "blob" }); // 下载开发者证书
const certificateList = (params: any) => post(`${baseUrl}/developerCert/page`, params); // 查询开发者证书列表
const certificateSelect = (params?: any) => post(`${baseUrl}/developerCert/listSelect`, params); // 开发者证书选择列表
const appCertAdd = (params: any) => post(`${baseUrl}/appCert/add`, params); // 新增应用证书
const appCertDownload = (params: any) => get(`${baseUrl}/appCert/download/${params.id}`, { responseType: "blob" }); // 下载应用证书
const appCertList = (params: any) => post(`${baseUrl}/appCert/page`, params); // 查询应用证书列表
const appCertDelete = (params: any) => post(`${baseUrl}/appCert/remove/${params.id}`); // 删除开发者证书
const appCertCheckRelease = (params: any) => post(`${baseUrl}/appCert/check/release`, params); // 查询当前应用下是否有已发布的应用证书

export default {
  certificateAdd,
  certificateAbolish,
  certificateDelete,
  certificateDownload,
  certificateList,
  certificateSelect,
  appCertAdd,
  appCertDownload,
  appCertList,
  appCertDelete,
  appCertCheckRelease,
};
